import { useState, useEffect } from "react"
import { useDispatch } from 'react-redux'
import { useCreateUserMutation, useGetUserRolesMutation, useGetBrokerTypesMutation } from "./userApiSlice"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { message } from 'antd'
import PasswordValidator from "./PasswordValidator"
import { isValidPassword } from "./utils/PasswordUtil"
import SupportStaffAdvisorPicker from "./SupportStaffAdvisorPicker"

const CreateUser = () => {
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [username, setUsername] = useState(null)
    const [password, setPassword] = useState(null)
    const [confirmPassword, setConfirmPassword] = useState(null)
    const [role, setRole] = useState(null)
    const [broker, setBroker] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [userRoles, setUserRoles] = useState([])
    const [connectedAdvisors, setConnectedAdvisors] = useState([])
    const [brokerTypes, setBrokerTypes] = useState([])

    const [messageApi, contextHolder] = message.useMessage()
    const dispatch = useDispatch()

    const [ createUser,  {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useCreateUserMutation()

    const [ getUserRoles,  {
    }] = useGetUserRolesMutation()

    const [ getBrokerTypes,  {
    }] = useGetBrokerTypesMutation()

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])

    useEffect(() => {
        if(isSuccess) {
            setFirstName("")
            setLastName("")
            setUsername("")
            setRole("")
            setPassword("")
            setConfirmPassword("")
            setBroker(null)
            setConnectedAdvisors([])
            alertMessage("User created")
        }
    }, [isSuccess])

    useEffect(() => {
        if(isError) {
            console.log(error)
            if(error?.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(error?.data)
            }
        }
    }, [isError])

    useEffect(() => {
        async function handleGetUserRoles() {
          const response = await getUserRoles()
          setUserRoles(response.data)
        }

        async function handleGetBrokerTypes() {
          const response = await getBrokerTypes()
          setBrokerTypes(response.data)
        }

        handleGetUserRoles()
        handleGetBrokerTypes()
    }, [])

    const alertMessage = (message) => {
        messageApi.success(message);
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        setErrorMessage("")
        if(!firstName) {
            setErrorMessage("First name is required.")
            return
        }

        if(!lastName) {
            setErrorMessage("Last name is required.")
            return
        }

        if(!username) {
            setErrorMessage("Username is required.")
            return
        }

        if(!role) {
            setErrorMessage("Role is required.")
            return
        }

        if(role === "ADVISOR" && !broker) {
            setErrorMessage("Broker/Dealer is required.")
            return
        }

        if(!password) {
            setErrorMessage("Password is required.")
            return
        }

        if(!isValidPassword(password)) {
            return
        }

        if(password !== confirmPassword) {
            setErrorMessage("Password does not match")
            return
        }
        
        await createUser({
            firstName,
            lastName,
            username, 
            password, 
            role, 
            broker: role === "ADVISOR" ? broker : null, 
            connectedAdvisors: role === "SUPPORT_STAFF" ? connectedAdvisors : null})
    }

    const createUserRoleOptions = () => {
        return userRoles.map(role => <option value={role.value}>{role.description}</option>)
    }

    const handleAddAdvisor = (advisor) => {
        let advisors = [...connectedAdvisors]
        advisors.push(advisor)
        setConnectedAdvisors(advisors)
    }

    const handleRemoveAdvisor = (id) => {
        let advisors = [...connectedAdvisors]
        let updated = advisors.filter(advisor => id !== advisor.id)

        setConnectedAdvisors(updated)
    }

    return(
        <div className="manage-user-container">
            {contextHolder}
            <div className='top-header'>
                <header>New User</header>
            </div>
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <form onSubmit={(e) => onSubmit(e)}>
                <div className="form-group">
                    <label for="firstName">First Name</label>
                    <input className="inpt" id="firstName" name="firstName" required value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label for="lastName">Last Name</label>
                    <input className="inpt" id="lastName" name="lastName" required value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label for="username">Username</label>
                    <input className="inpt" id="username" name="username" required value={username} onChange={(e) => setUsername(e.target.value)} />
                </div>
                <div className="form-group">
                    <label for="role">User Role</label>
                    <select className="inpt" id="role" name="role" value={role} required onChange={(e) => setRole(e.target.value)} > 
                        <option disabled selected value="">User Role</option>
                        {createUserRoleOptions()}
                    </select>
                </div>
                {
                    role === "ADVISOR" &&
                    <div className="form-group">
                        <label for="broker">Broker/Dealer</label>
                        <select className="inpt" id="broker" name="broker" value={broker} required onChange={(e) => setBroker(e.target.value)} > 
                            <option disabled selected value="">Broker/Dealer</option>
                            {brokerTypes.map(type => <option value={type.value}>{type.label}</option>)}
                        </select>
                    </div>
                }

                {
                    role === "SUPPORT_STAFF" &&
                    <SupportStaffAdvisorPicker 
                        handleAddAdvisor={handleAddAdvisor} 
                        handleRemoveAdvisor={handleRemoveAdvisor}
                        updatedConnectedAdvisors={connectedAdvisors} 
                    />
                }

                <div className="form-group">
                    <label for="password">Password</label>
                    <input className="inpt" type='password' id="password" name="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <PasswordValidator password={password} />
                <div className="form-group">
                    <label for="confirmPassword">Confirm Password</label>
                    <input className="inpt" type='password' id="confirmPassword" name="confirmPassword" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                </div>
                <div className="form-group">
                    <button className="crm-button" type="submit">Create User</button>
                </div>
            </form>
        </div>
    )
}

export default CreateUser